import { Controller } from '@hotwired/stimulus';

class ReadMoreController extends Controller {
  private open = false;
  declare private readonly contentTarget: HTMLElement;
  declare private readonly moreTextValue: string;
  declare private readonly lessTextValue: string;

  public static readonly targets: string[] = ['content'];
  public static readonly values = {
    moreText: String,
    lessText: String
  };

  public connect(): void {
    this.open = false;
    this.contentTarget
      .querySelectorAll('*')
      .forEach(el =>
        el.addEventListener('focus', () => this._preventFocusWhenHidden())
      );
  }

  public toggle(event: Event): void {
    if (this.open) {
      this.hide(event);
    } else {
      this.show(event);
    }
  }

  public show(event: Event): void {
    this.open = true;

    const target = event.target as HTMLElement;

    target.innerHTML = this.lessTextValue;
    this.contentTarget.classList.add('show');
  }

  public hide(event: Event): void {
    this.open = false;

    const target = event.target as HTMLElement;

    target.innerHTML = this.moreTextValue;
    this.contentTarget.classList.remove('show');
  }

  private _preventFocusWhenHidden() {
    if (!this.open) {
      this.contentTarget.scrollTop = 0;
      this.contentTarget.scrollLeft = 0;
    }
  }
}

export default ReadMoreController;
